import { Typography } from '@equinor/eds-core-react'
import {
    AboutPageContainer,
    TextContainer,
    ImageContainer,
    StyledLink,
    TextAndImageContainer,
    TitleContainer,
    ColumnsWrapper,
} from '@/components/styles/AboutStyles'

function About() {
    return (
        <>
            <AboutPageContainer>
                <TitleContainer>
                    <Typography variant="h1">About</Typography>
                </TitleContainer>
                <ColumnsWrapper>
                    <TextAndImageContainer>
                        <TextContainer>
                            <Typography variant="h3"> What is IIoT? </Typography>
                            <Typography variant="body_short">
                                The term Industrial Internet of Things (IIoT) refers to a network of wireless
                                battery-powered sensors monitoring industrial equipment. IIoT provides a simple and
                                affordable way to gather and transmit data for monitoring and optimization (M+O) of
                                industrial systems and processes.
                                <br />
                                <br />
                            </Typography>
                            <Typography variant="h3">What does IIoT enable?</Typography>
                            <Typography variant="body_short">
                                While traditional instrumentation often requires significant time and effort to install
                                after a problem is detected, IIoT enables on-demand instrumentation, allowing monitoring
                                to be added exactly when and where issues arise. Low-cost wireless sensors make
                                large-scale monitoring feasible and offer greater flexibility in sensor placement
                                compared to traditional instrumentation.
                                <br />
                                <br />
                            </Typography>
                            <Typography variant="h3"> What's different from traditional instrumentation? </Typography>
                            <Typography variant="body_short">
                                It should be emphasized that IIoT complements traditional instruments, it does not
                                replace traditional instruments. For non-critical use-cases without need for high
                                frequent measurements, IIoT is an excellent solution both cost, time and usability-wise
                                compared to WirelessHART / ISA100 or wired instruments.
                                <br />
                                <br />
                                Measurements from IIoT sensors never enter the technical network, and reside outside the
                                IMS systems (PI/Aspen). This is a deliberate design to ensure cost-effectiveness, easy
                                installation/maintenance and cybersecurity. Instead the measurements are routed securely
                                from field to cloud (the Omnia platform), where they can be found in tools such a IOC's
                                Almond or the Trending App.
                            </Typography>
                        </TextContainer>
                    </TextAndImageContainer>
                    <TextAndImageContainer>
                        <TextContainer>
                            <Typography variant="h3">Who are working with IIoT in Equinor?</Typography>
                            <Typography variant="body_short">
                                We are a multidisciplinary team dedicated to enabling IIoT solutions across Equinor. Our
                                group is part of TDI, under Asset Autonomy and Advanced Analytics & Control. TDI is
                                committed to realizing Equinor’s ambition of becoming{' '}
                                <StyledLink href="https://www.equinor.com/no/energi/digitalisering" target="_blank">
                                    The Digital Energy Company
                                </StyledLink>
                                , with IIoT playing a key role in that journey.
                                <br />
                                <br />
                                Our main focus is developing a digital tool that supports the entire lifecycle of IIoT
                                sensors, from procurement to installation and decommissioning.
                                <br />
                                <br />
                                If you would like to get in touch, please contact us at:{' '}
                                <StyledLink href="mailto:gm_TDI_IIoT_Sensors@equinor.com">
                                    gm_TDI_IIoT_Sensors@equinor.com
                                </StyledLink>
                                . To get started with IIoT sensors, visit{' '}
                                <StyledLink href={'/howto'}>How to get started</StyledLink>.
                            </Typography>
                        </TextContainer>
                        <br />
                        <ImageContainer>
                            <img src="/IIoT_logo.png" style={{ maxWidth: '400px' }} />
                        </ImageContainer>
                    </TextAndImageContainer>
                </ColumnsWrapper>
            </AboutPageContainer>
        </>
    )
}

export default About
